export enum ChannelType {
    FOR_SALE = 'for-sale',
    NEW_HOMES = 'new-homes',
    HOMEPAGE = 'homepage'
}
